module.exports = __webpack_public_path__ + "images/dae211afef6f37ef0693de928af80cd9.svg";